<template>
  <div>
    <div class="row no-gutters px-3 py-3" v-if="!interview_id">
      <div class="mr-3 col-auto">
        <h2 class="text-center">
          {{ schedule.start_time | moment("HH:ss") }}
          <template v-if="!report">
          <a
            class="edit svg pointer"
            @click.prevent="$emit('update-schedule-date', schedule.id)"
            v-if="
              pcase.status !== 'completed' && schedule.status !== 'completed'
            "
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="calendar-edit"
              class="svg-inline--fa fa-calendar-edit fa-w-14"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M0 192v272a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V192zm274.43 163.57l-95 95L131.2 456a10.17 10.17 0 0 1-11.2-9 9.93 9.93 0 0 1 0-2.18l5.4-48.2 95-95a5.07 5.07 0 0 1 7.17 0l46.8 46.8a5.07 5.07 0 0 1 .06 7.15zm55.67-55.67l-26 26a5.07 5.07 0 0 1-7.17 0l-46.8-46.8a5.07 5.07 0 0 1 0-7.17l26-26a20.22 20.22 0 0 1 28.6 0l25.4 25.4a20.22 20.22 0 0 1-.03 28.57zM112 128h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm192 0h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16z"
                  opacity="0.4"
                ></path>
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M330.1 271.3l-25.4-25.4a20.22 20.22 0 0 0-28.6 0l-26 26a5.07 5.07 0 0 0 0 7.17l46.8 46.8a5.07 5.07 0 0 0 7.17 0l26-26a20.22 20.22 0 0 0 0-28.6zm-55.7 77.1l-46.8-46.8a5.07 5.07 0 0 0-7.17 0l-95 95-5.43 48.2a10.17 10.17 0 0 0 9 11.2 9.93 9.93 0 0 0 2.18 0l48.2-5.4 95-95a5.07 5.07 0 0 0 0-7.17zM400 64h-48v48a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V64H160v48a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V64H48a48 48 0 0 0-48 48v80h448v-80a48 48 0 0 0-48-48z"
                ></path>
              </g>
            </svg>
          </a>
          <a class="svg text-success" v-else>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="calendar-check"
              class="svg-inline--fa fa-calendar-check fa-w-14"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M0 192v272a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V192zm345.26 113l-143 141.8a12 12 0 0 1-17 0l-82.6-83.26a12 12 0 0 1 .06-17l.08-.08 28.4-28.17a12 12 0 0 1 17 0l46 46.36 106-105.19a12 12 0 0 1 17 0L345.3 288a12 12 0 0 1-.04 17zM304 128h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm-192 0h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16z"
                  opacity="0.4"
                ></path>
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M345.33 288l-28.2-28.4a12 12 0 0 0-17-.1l-106 105.19-46-46.36a12 12 0 0 0-17-.09l-28.4 28.17a12 12 0 0 0-.1 17l82.6 83.26a12 12 0 0 0 17 .1l143-141.8a12 12 0 0 0 .1-17zM400 64h-48v48a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V64H160v48a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V64H48a48 48 0 0 0-48 48v80h448v-80a48 48 0 0 0-48-48z"
                ></path>
              </g>
            </svg>
          </a>
          </template>
        </h2>
        <span class="badge badge-primary d-block">
          {{ schedule.start_time | moment("DD MMM YYYY") }}
        </span>
        <div class="mt-2">
          <InterviewScheduleLink
            :schedule="schedule"
            :on-click="interviewClicked"
          ></InterviewScheduleLink>
        </div>
      </div>
      <div
        class="col"
        v-if="pcase.status !== 'completed' && schedule.status === 'activated'"
      >
        <textarea
          class="form-control h-100"
          v-model="comment"
          @blur="save"
        ></textarea>
      </div>
      <div class="col" v-else>
        <pre class="text-wrap">{{ comment }}</pre>
      </div>
      <div
        class="col-auto ml-2"
        v-if="
          pcase.status !== 'completed' &&
          schedule.status !== 'completed' &&
          schedule.status !== 'activated'
        "
      >
        <!-- {{ schedule.status }} -->
        <a
          class="svg-lg pointer text-center d-block text-secondary"
          @click.prevent="$emit('activate-schedule', schedule.id)"
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fad"
            data-icon="calendar-plus"
            class="svg-inline--fa fa-calendar-plus fa-w-14"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <g class="fa-group">
              <path
                class="fa-secondary"
                fill="currentColor"
                d="M0 192v272a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V192zm328 180a12 12 0 0 1-12 12h-60v60a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-60h-60a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h60v-60a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12v60h60a12 12 0 0 1 12 12zm-24-244h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm-192 0h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16z"
                opacity="0.4"
              ></path>
              <path
                class="fa-primary"
                fill="currentColor"
                d="M316 320h-60v-60a12 12 0 0 0-12-12h-40a12 12 0 0 0-12 12v60h-60a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h60v60a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-60h60a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm84-256h-48v48a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V64H160v48a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V64H48a48 48 0 0 0-48 48v80h448v-80a48 48 0 0 0-48-48z"
              ></path>
            </g>
          </svg>
          <small class="d-block uppercase mt-1">გააქტიურება</small>
        </a>
      </div>
      <div
        class="col-auto ml-2"
        v-if="pcase.status !== 'completed' && schedule.status === 'activated'"
      >
        <a
          class="svg-lg pointer text-center d-block text-success"
          @click.prevent="$emit('complete-schedule', schedule.id)"
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fad"
            data-icon="calendar-check"
            class="svg-inline--fa fa-calendar-check fa-w-14"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <g class="fa-group">
              <path
                class="fa-secondary"
                fill="currentColor"
                d="M0 192v272a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V192zm345.26 113l-143 141.8a12 12 0 0 1-17 0l-82.6-83.26a12 12 0 0 1 .06-17l.08-.08 28.4-28.17a12 12 0 0 1 17 0l46 46.36 106-105.19a12 12 0 0 1 17 0L345.3 288a12 12 0 0 1-.04 17zM304 128h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm-192 0h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16z"
                opacity="0.4"
              ></path>
              <path
                class="fa-primary"
                fill="currentColor"
                d="M345.33 288l-28.2-28.4a12 12 0 0 0-17-.1l-106 105.19-46-46.36a12 12 0 0 0-17-.09l-28.4 28.17a12 12 0 0 0-.1 17l82.6 83.26a12 12 0 0 0 17 .1l143-141.8a12 12 0 0 0 .1-17zM400 64h-48v48a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V64H160v48a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V64H48a48 48 0 0 0-48 48v80h448v-80a48 48 0 0 0-48-48z"
              ></path>
            </g>
          </svg>
          <small class="d-block uppercase mt-1">დასრულება</small>
        </a>
      </div>
    </div>
    <div v-else class="position-relative pt-5">
      <a
        class="back-btn text-primary pointer px-3 py-2 border-bottom w-100"
        @click="interview_id = null"
      >
        <BackIcon></BackIcon>
        {{ schedule.start_time | moment("DD MMMM YYYY HH:ss") }}
      </a>
      <Interview :interview-id="interview_id"></Interview>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import InterviewScheduleLink from '@/components/Interviews/ScheduleLink'
import Interview from '@/components/Interviews/Interview'
import BackIcon from '@/components/Icons/Back'
export default {
  components: {
    InterviewScheduleLink,
    Interview,
    BackIcon
  },
  props: {
    scheduleId: {
      type: String,
      required: true
    },
    caseId: {
      type: String,
      required: true
    },
    report: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      comment: null,
      interview_id: null
    }
  },
  computed: {
    ...mapGetters({
      caseById: 'pcase/byId',
      scheduleById: 'schedule/byId'
    }),
    pcase () {
      return this.caseById(this.caseId)
    },
    schedule () {
      return this.scheduleById(this.scheduleId)
    }
  },
  mounted () {
    this.comment = '' + this.schedule.comment
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setSchedule: 'schedule/set'
    }),
    interviewClicked (id) {
      this.interview_id = id
    },
    async save () {
      try {
        const params = {
          comment: this.comment
        }
        const response = await this.axios.post(
          `/api/schedules/${this.schedule.id}/comment`,
          params
        )
        const schedule = response.data.data
        this.setSchedule(schedule)
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
